import { useEffect } from 'react'
import { prefetchDNS } from 'react-dom'

import { SettingScreenPolicies } from '../atoms'
import { getEmbeddedPolicyUrl } from '../model'

export function useWarmPolicyIframes(policiesHost: string, open: boolean) {
  useEffect(() => {
    if (!open) {
      return
    }

    return warmPolicyIframes(policiesHost)
  }, [policiesHost, open])
}

const POLICY_WARMING_DELAY = 200

function warmPolicyIframes(policiesHost: string) {
  prefetchDNS(policiesHost)
  const warmed: Array<HTMLIFrameElement> = []
  const timeoutIds: Array<ReturnType<typeof setTimeout>> = []

  for (const [index, policy] of SettingScreenPolicies.entries()) {
    const timeoutId = setTimeout(() => {
      const iframe = document.createElement('iframe')
      iframe.src = getEmbeddedPolicyUrl(policiesHost, policy)
      iframe.hidden = true
      iframe.tabIndex = -1
      iframe.setAttribute('aria-hidden', 'true')
      iframe.style.cssText =
        'position:absolute;width:0;height:0;border:0;visibility:hidden'
      document.body.appendChild(iframe)
      warmed.push(iframe)
    }, index * POLICY_WARMING_DELAY)
    timeoutIds.push(timeoutId)
  }

  return () => {
    for (const timeoutId of timeoutIds) {
      clearTimeout(timeoutId)
    }
    for (const iframe of warmed) {
      iframe.remove()
    }
  }
}
